import { render, staticRenderFns } from "./IPDPatientProfileCharts.vue?vue&type=template&id=b6151316&"
import script from "./IPDPatientProfileCharts.vue?vue&type=script&lang=js&"
export * from "./IPDPatientProfileCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports